import React from "react";
import {
  JavaScriptSVG,
  BootstrapSVG,
  CSSSVG,
  GitSVG,
  GithubSVG,
  GraphQLSVG,
  HerokuSVG,
  HTMLSVG,
  JQuerySVG,
  MongoDBSVG,
  MySQLSVG,
  NodeSVG,
  NPMSVG,
  ReactSVG,
  ReduxSVG,
  SassSVG,
  WebpackSVG
} from "../components/SVGs";

const skills = [
  {
    comp: <JavaScriptSVG color={"#F7DF1E"} />,
    color: "#F7DF1E"
  },
  {
    comp: <BootstrapSVG color={"#563D7C"} />,
    color: "#563D7C"
  },
  {
    comp: <CSSSVG color={"#1572B6"} />,
    color: "#1572B6"
  },
  {
    comp: <GitSVG color={"#F05032"} />,
    color: "#F05032"
  },
  {
    comp: <GithubSVG color={"#181717"} />,
    color: "#181717"
  },
  {
    comp: <GraphQLSVG color={"#E10098"} />,
    color: "#E10098"
  },
  {
    comp: <HerokuSVG color={"#430098"} />,
    color: "#430098"
  },
  {
    comp: <HTMLSVG color={"#E34F26"} />,
    color: "#E34F26"
  },
  {
    comp: <JQuerySVG color={"#0769AD"} />,
    color: "#0769AD"
  },
  {
    comp: <MongoDBSVG color={"#47A248"} />,
    color: "#47A248"
  },
  {
    comp: <MySQLSVG color={"#4479A1"} />,
    color: "#4479A1"
  },
  {
    comp: <NodeSVG color={"#339933"} />,
    color: "#339933"
  },
  {
    comp: <NPMSVG color={"#CB3837"} />,
    color: "#CB3837"
  },
  {
    comp: <ReactSVG color={"#61DAFB"} />,
    color: "#61DAFB"
  },
  {
    comp: <ReduxSVG color={"#764ABC"} />,
    color: "#764ABC"
  },
  {
    comp: <SassSVG color={"#CC6699"} />,
    color: "#CC6699"
  },
  {
    comp: <WebpackSVG color={"#8DD6F9"} />,
    color: "#8DD6F9"
  }
];

export default skills;
